import {
    Search,
    Funnel,
    Edit2,
    Plus,
    MoreHorizontal,
    ChevronsUpDown,
    ChevronLeft,
    ChevronRight,
    X,
    Copy,
    SquareArrowOutUpRight,
    CircleCheck,
    ChevronUp, ChevronDown,
    FunnelPlus
} from 'lucide-react';
import { useHistory, useLocation } from "react-router-dom";
import React, { useState, useRef, useEffect, useMemo } from 'react';
import noImage from '../assets/img/brand/noImage.png';
import ConfirmDeactivateModal from './ConfirmDeactivateModal';
import ConfirmArchiveModal from './ConfirmArchiveModal';
import AlertNotification from './AlertNotification';
import apiHelper from '../apiHelper';
import { formatDateTime } from '../utils/formateDate';

const CategoryInfoDrawer = ({
  selectedRow,
  setSelectedRow,
  setCategoryDrawerOpen,
  setSpuDrawerOpen,
  categoriesData,
  setCategoriesData
}) => {
    const history = useHistory();
    const toolbarRef = useRef(null);
    const drawerRef = useRef(null);
    const openIdRef = useRef(null);
    const archivedRef = useRef(null);
    const [archivedModalOpen, setArchivedModalOpen] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [drawerTab, setDrawerTab] = useState('general-info');
    // const [brandsData, setBrandsData] = useState(brandsData);
    const [toolbarDropdownOpen, setToolbarDropdownOpen] = useState(false);
    const [imageModalOpen, setImageModalOpen] = useState(false);
    const [copied, setCopied] = useState(false);
    const [deactivateModalOpen, setDeactivateModalOpen] = useState(false);
    const [selectedBrandId, setSelectedBrandId] = useState(null);
    const [spuLinkedModalOpen, setSpuLinkedModalOpen] = useState(false);
    const [linkedModalMessage, setLinkedModalMessage] = useState("");
    const [previousCategory, setPreviousCategory] = useState(null);
    const [categoryToDeactivate, setCategoryToDeactivate] = useState(null);
    const [deactivateActionType, setDeactivateActionType] = useState('deactivate'); // 'deactivate' or 'activate'
    const [alertNotification, setAlertNotification] = useState({
        show: false,
        type: 'success', // 'success' or 'error'
        recordName: '',
        action: '' // 'create', 'update', 'discard', 'activate', 'deactivate', 'archive'
    });
    const toggleToolbarDropdown = () => {
        setToolbarDropdownOpen(prev => !prev);
    };
    const [archiveModalOpen, setArchiveModalOpen] = useState(false);
    const [spuValidationModalOpen, setSpuValidationModalOpen] = useState(false);
    const [categoryToArchive, setCategoryToArchive] = useState(null);
    const [archiveMessage, setArchiveMessage] = useState('');
    const [archivedCategories, setArchivedCategories] = useState([]);

    const pageData = categoriesData;

    const isCategoryNameOverflowing = (categoryName) => {
        if (!categoryName) return false;
        // Consider category name lengthy if it's more than 30 characters
        return categoryName.length > 30;
    };

    const handleCopy = async (textToCopy) => {
        if (!textToCopy) {
            console.error('No text to copy');
            alert('Failed to copy: No text available.');
            return;
        }

        // Use Clipboard API if available and secure
        if (window.isSecureContext && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            try {
                await navigator.clipboard.writeText(textToCopy);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
            } catch (err) {
                console.error('Clipboard API failed:', err);
                fallbackCopyTextToClipboard(textToCopy);
            }
        } else {
            console.warn('Clipboard API not available or not in secure context, using fallback');
            fallbackCopyTextToClipboard(textToCopy);
        }
    };

    const fallbackCopyTextToClipboard = (text) => {
        try {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.top = '0';
            textArea.style.left = '0';
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            const successful = document.execCommand('copy');
            document.body.removeChild(textArea);

            if (successful) {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            } else {
                console.error('Fallback copy failed');
                alert('Failed to copy text. Please copy manually.');
            }
        } catch (err) {
            console.error('Fallback copy error:', err);
            alert('Failed to copy text. Please copy manually.');
        }
    };

    const handleDeactivateBrand = async (brandId) => {
        console.log('Deactivating brand ID:', brandId);
        if (!brandId) return;
        console.log('Deactivating brand ID:', brandId);
        try {
            const response = await apiHelper(`inventory/brands/${brandId}/deactivate/`, 'POST');
            if (response.ok) {
                const data = await response.json();
                const isActive = data.status;
                const newStatusText = isActive ? "Active" : "Inactive";
                setSuccessMessage(data.detail || 'Status updated successfully.');
                setCategoriesData(prev =>
                    prev.map(brand =>
                        brand.brand_id === brandId
                            ? { ...brand, status: isActive, status_text: newStatusText }
                            : brand
                    )
                );
                // ✅ also update selectedRow if it's the same branch
                setSelectedRow(prev =>
                    prev && prev.brand_id === brandId
                        ? { ...prev, status: isActive, status_text: newStatusText }
                        : prev
                );
                // setDropdownOpenId(null);
                setDeactivateModalOpen(false);
            } else {
                const error = await response.json();
                console.error("Error toggling brand status:", error);
                setDeactivateModalOpen(false);
            }
        } catch (err) {
            console.error("Network/server error while toggling brand status:", err);
        }
    };

    const handleArchivedConfirm = async (brandId) => {
        if (!brandId) return;
    
        try {
            const response = await apiHelper(`inventory/brands/${brandId}/archive/`, 'POST');
            if (response.ok) {
                const data = await response.json();
                setSuccessMessage(data.detail || 'Brand Archived Successfully');
                
                // Get the brand name before removing it
                const archivedBrandName = categoriesData.find(brand => brand.brand_id === brandId)?.brand_name;
                
                // 1. Remove the archived brand
                /*setBrandsData(prev => prev.filter(brand => brand.brand_id !== brandId));
                
                // 2. Update all child brands to remove the archived parent reference
                setBrandsData(prev => prev.map(brand => {
                    if (brand.parent_name === archivedBrandName) {
                        return {
                            ...brand,
                            parent_name: null,
                            parent_brand: null,
                            parent_brand_name: null
                        };
                    }
                    return brand;
                }));*/
    
                // 4. Update the selected row if it's a child of the archived brand
                // if (selectedRow && selectedRow.parent_name === archivedBrandName) {
                //     setSelectedRow(prev => ({
                //         ...prev,
                //         parent_name: null,
                //         parent_brand: null,
                //         parent_brand_name: null
                //     }));
                // }
    
                // 5. Update pageData (filtered brands) to reflect changes
                // This will happen automatically when brandsData updates and filtered recomputes
                
                // fetchArchivedBrands();
                // setDrawerOpen(false);
            } else if (response.status === 400) {
                const response_errors = await response.json();
    
                if (response_errors.detail === "Cannot archive this brand. SPUs are linked to it.") {
                    setSpuLinkedModalOpen(true);
                    setLinkedModalMessage("This brand can't be archived because it's referenced by one or more SPUs. Please remove or reassign those SPUs before archiving.");
                } else if(response_errors.detail === "Cannot archive this brand. other brands are linked to it.") {
                    setSpuLinkedModalOpen(true);
                    setLinkedModalMessage(response_errors.detail);
                } else {
                    let errors = [];
                    for (let i in response_errors) {
                        errors.push(`${i}: ${response_errors[i][0]}`);
                    }
                    // setValidationError(errors);
                    setSuccessMessage('');
                }
            }
        } catch (error) {
            console.error("Error archiving brand:", error);
            setSuccessMessage('');
        }
        setArchivedModalOpen(false);
    };

    const openArchiveModal = (categoryId, categoryName = '') => {
        setCategoryToArchive(categoryId);
        setArchiveModalOpen(true);
    };

    
    const handleParentCategoryClick = async (parentCategoryId) => {
        if (!parentCategoryId) return;
        // categoriesData may not contain the parent (paged/filtered), so fall back to the API.
        let parentCategory = (categoriesData || []).find(category => category.category_id === parentCategoryId);
        if (!parentCategory) {
            try {
                const res = await apiHelper(`inventory/categories/show/${parentCategoryId}/`, 'GET');
                if (res.ok) parentCategory = await res.json();
            } catch (e) {
                console.error('Error fetching parent category:', e);
            }
        }
        if (parentCategory) {
            setPreviousCategory(selectedRow);
            setSelectedRow(parentCategory);
            setDrawerTab('general-info');
        }
    };

    const handleActivateCategory = async (categoryId) => {
        if (!categoryId) {
            console.error("No category ID found");
            return;
        }

        try {
            const response = await apiHelper(`inventory/categories/${categoryId}/deactivate/`, 'POST');

            if (response.ok) {
                const data = await response.json();
                console.log("Category activated successfully:", data);

                const isActive = data.status;
                const newStatusText = isActive ? "Active" : "Inactive";

                setAlertNotification({
                    show: true,
                    type: 'success',
                    recordName: 'Category',
                    action: 'activate'
                });

                setCategoriesData(prev => prev.map(cat =>
                    cat.category_id === categoryId
                        ? { ...cat, status: isActive, status_text: newStatusText }
                        : cat
                ));

                setSelectedRow(prev =>
                    prev && prev.category_id === categoryId
                        ? { ...prev, status: isActive, status_text: newStatusText }
                        : prev
                );

                // setDropdownOpenId(null);
                setToolbarDropdownOpen(false);

                // Keep drawer open - no changes needed here
            } else {
                const error = await response.json();
                console.error("Error activating category:", error);
                setAlertNotification({
                    show: true,
                    type: 'error',
                    recordName: 'Category',
                    action: 'activate'
                });
            }
        } catch (err) {
            console.error("Network/server error while activating category:", err);
            setAlertNotification({
                show: true,
                type: 'error',
                recordName: 'Category',
                action: 'activate'
            });
        }
    };

    const openDeactivateModal = (categoryId, actionType = 'deactivate') => {
        // CHANGED: If activating, don't show confirmation modal, just activate directly
        if (actionType === 'activate') {
            handleActivateCategory(categoryId);
            return;
        }

        // For deactivate, show confirmation modal
        setCategoryToDeactivate(categoryId);
        setDeactivateActionType(actionType);
        setDeactivateModalOpen(true);
    };
    // FIXED: Modified handleDeactivateConfirm to keep drawer open
    const handleDeactivateConfirm = async () => {
        if (!categoryToDeactivate) {
            console.error("No category ID found");
            return;
        }

        try {
            const response = await apiHelper(`inventory/categories/${categoryToDeactivate}/deactivate/`, 'POST');

            if (response.ok) {
                const data = await response.json();
                console.log("Category status toggled successfully:", data);

                const isActive = data.status;
                const newStatusText = isActive ? "Active" : "Inactive";

                setAlertNotification({
                    show: true,
                    type: 'success',
                    recordName: 'Category',
                    action: deactivateActionType
                });

                setCategoriesData(prev => prev.map(cat =>
                    cat.category_id === categoryToDeactivate
                        ? { ...cat, status: isActive, status_text: newStatusText }
                        : cat
                ));

                setSelectedRow(prev =>
                    prev && prev.category_id === categoryToDeactivate
                        ? { ...prev, status: isActive, status_text: newStatusText }
                        : prev
                );

                setDeactivateModalOpen(false);
                setCategoryToDeactivate(null);
                // setDropdownOpenId(null);
                setToolbarDropdownOpen(false);

                // FIXED: Don't close the drawer - keep it open
                // Removed the code that was closing the drawer
            } else {
                const error = await response.json();
                console.error("Error toggling category status:", error);
                setAlertNotification({
                    show: true,
                    type: 'error',
                    recordName: 'Category',
                    action: deactivateActionType
                });
                setDeactivateModalOpen(false);
            }
        } catch (err) {
            console.error("Network/server error while toggling category status:", err);
            setAlertNotification({
                show: true,
                type: 'error',
                recordName: 'Category',
                action: deactivateActionType
            });
            setDeactivateModalOpen(false);
        }
    };
    const deduplicateById = (data) => {
        const seen = new Set();
        return data.filter(item => {
            if (!item.category_id) return false;
            if (seen.has(item.category_id)) return false;
            seen.add(item.category_id);
            return true;
        });
    };
    const fetchArchivedCategories = async () => {
        try {
            const response = await apiHelper('inventory/categories/?is_archived=true', 'GET');
            if (response.ok) {
                const data = await response.json();
                console.log("Archived categories fetched:", data);
                setArchivedCategories(deduplicateById(data));
            } else {
                const error = await response.json();
                console.error("Failed to fetch archived categories:", error);
            }
        } catch (error) {
            console.error("Error fetching archived categories:", error);
        }
    };


    // FIXED: Modified handleArchiveConfirm to keep drawer open
    const handleArchiveConfirm = async (categoryId) => {
        if (!categoryId) {
            console.error("No category ID selected");
            return;
        }

        try {
            const response = await apiHelper(`inventory/categories/${categoryId}/check-archive/`, 'POST');

            if (response.ok) {
                const data = await response.json();

                setAlertNotification({
                    show: true,
                    type: 'success',
                    recordName: 'Category',
                    action: 'archive'
                });

                // Get the category name before removing it
                const archivedCategoryName = categoriesData.find(cat => cat.category_id === categoryId)?.category_name;

                // 1. Remove the archived category
                setCategoriesData(prev => prev.filter(cat => cat.category_id !== categoryId));

                // 2. Update all child categories to remove the archived parent reference
                setCategoriesData(prev => prev.map(cat => {
                    if (cat.parent_name === archivedCategoryName) {
                        return {
                            ...cat,
                            parent_name: null,
                            parent_parent_name: null
                        };
                    }
                    return cat;
                }));

                // 3. Also update archived categories if any child was already archived
                setArchivedCategories(prev => prev.map(cat => {
                    if (cat.parent_name === archivedCategoryName) {
                        return {
                            ...cat,
                            parent_name: null,
                            parent_parent_name: null
                        };
                    }
                    return cat;
                }));

                // 4. Update filtered data for immediate UI update
                // This updates the child categories in the current view
                // We need to update the filtered state as well
                const updatedCategories = categoriesData
                    .filter(cat => cat.category_id !== categoryId)
                    .map(cat => {
                        if (cat.parent_name === archivedCategoryName) {
                            return {
                                ...cat,
                                parent_name: null,
                                parent_parent_name: null
                            };
                        }
                        return cat;
                    });

                // This will trigger a re-render with updated data
                // Note: categories state will be updated by setCategories above,
                // but we also need to ensure filtered state gets the updated data

                // 5. Update the selected row if it's a child of the archived category
                if (selectedRow && selectedRow.parent_name === archivedCategoryName) {
                    setSelectedRow(prev => ({
                        ...prev,
                        parent_name: null,
                        parent_parent_name: null
                    }));
                }

                // 6. If the drawer is open for a child category, update its parent display
                // This ensures the drawer shows the updated parent info
                // if (drawerOpen && selectedRow && selectedRow.parent_name === archivedCategoryName) {
                    // The drawer will re-render with the updated selectedRow
                    // No additional action needed as selectedRow is already updated above
                // }

                await fetchArchivedCategories();

                setArchiveModalOpen(false);
                setCategoryToArchive(null);

            } else {
                const errorData = await response.json();
                if (errorData.error && errorData.linked_spus_count > 0) {
                    setArchiveMessage(errorData.error);
                    setSpuValidationModalOpen(true);
                    setArchiveModalOpen(false);
                } else {
                    console.error("Error archiving category:", errorData);
                    setAlertNotification({
                        show: true,
                        type: 'error',
                        recordName: 'Category',
                        action: 'archive'
                    });
                    setArchiveModalOpen(false);
                }
            }
        } catch (err) {
            console.error("Error archiving category:", err);
            setAlertNotification({
                show: true,
                type: 'error',
                recordName: 'Category',
                action: 'archive'
            });
            setArchiveModalOpen(false);
        }
    };


  return (
    <>
        {/* AlertNotification Component - Updated to match component structure with higher z-index */}
        {alertNotification.show && (
            <AlertNotification
                type={alertNotification.type}
                recordName={alertNotification.recordName}
                action={alertNotification.action}
                onClose={() => setAlertNotification(prev => ({ ...prev, show: false }))}
                style={{ zIndex: 1100 }} // Higher than drawer z-index
            />
        )}
        {/* Deactivate Confirmation Modal */}
        <ConfirmDeactivateModal
            isOpen={deactivateModalOpen}
            onCancel={() => {
                setDeactivateModalOpen(false);
                setCategoryToDeactivate(null);
            }}
            onConfirm={handleDeactivateConfirm}
            entityName="category"
            actionType={deactivateActionType}
        />

        {/* Archive Confirmation Modal */}
        <ConfirmArchiveModal
            isOpen={archiveModalOpen}
            onCancel={() => setArchiveModalOpen(false)}
            onConfirm={() => handleArchiveConfirm(categoryToArchive)}
            entityName="Category"
        />

        {/* SPU Validation Error Modal */}
        {spuValidationModalOpen && (
            <>
                <div className="drawer-overlay" />
                <div className="entity-drawer modal-popup-cls"
                    style={{
                        maxWidth: 500,
                        margin: "0 auto",
                        background: "white",
                        borderRadius: 12,
                        zIndex: 1050,
                        padding: 24,
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                        height: "auto",
                        right: "auto",
                        overflow: "inherit",
                    }}>
                    <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                        <button className="close-btn" onClick={() => setSpuValidationModalOpen(false)}>
                            <X size={20} />
                        </button>
                    </div>
                    <h3 style={{
                        textAlign: "left",
                        color: "#212529",
                        fontSize: "20px",
                        fontWeight: "600",
                        lineHeight: "24px",
                        fontFamily: "Montserrat",
                        marginBottom: "16px"
                    }}>
                        The category can't be archive
                    </h3>
                    <p style={{
                        marginBottom: "24px",
                        textAlign: "left",
                        color: "#6C757D",
                        fontSize: "14px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        fontFamily: "Montserrat"
                    }}>
                        {archiveMessage}
                    </p>
                    <div className="drawer-footer" style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        paddingTop: "10px"
                    }}>
                        <button
                            className="btn-save"
                            onClick={() => {
                                setSpuValidationModalOpen(false);
                                setArchiveMessage('');
                            }}
                            style={{
                                background: "#000",
                                color: "#fff",
                                border: "none",
                                borderRadius: "6px",
                                padding: "8px 16px",
                                cursor: "pointer",
                                fontWeight: "500",
                            }}
                        >
                            OK
                        </button>
                    </div>
                </div>
            </>
        )}
        <div
            className="drawer-overlay"
            onMouseDown={(e) => {
                // Outside click returns to the previous (parent) drawer.
                e.stopPropagation();
                setCategoryDrawerOpen(false);
            }}
        />
        <div className="entity-drawer" ref={drawerRef}>
            <div className="drawer-header aa" style={{ backgroundColor: "var(--Gray-100, #F8F9FA)" }}>
                <div className="d-flex align-items-center gap-1">
                    
                    <button
                        className="back-btn"
                        onClick={() => { 
                            if(previousCategory) {
                                setSelectedRow(previousCategory);
                                setPreviousCategory(null);
                            } else {
                                setCategoryDrawerOpen(false);
                            }
                        }}
                        style={{ backgroundColor: 'transparent', border: 'none', padding: 0, margin: 0 }}
                    >
                        <ChevronLeft size={24} />
                    </button>
                    
                    <h3>Category Info</h3>
                </div>
                <button
                    className="close-btn"
                    onClick={() => {
                        // setDrawerOpen(false);
                        // setSelectedIds(ids => ids.filter(id => id !== selectedRow?.external_id));
                        setSelectedRow(null);
                        setCategoryDrawerOpen(false); // close Category drawer
                        setSpuDrawerOpen(false); // close SPU drawer
                        // setNavigationStack([]);
                    }}
                >
                    <X size={18} />
                </button>
            </div>
            <div className="main-drawer-inner">
                <div className="drawer-title d-flex align-items-center justify-content-between" style={{ borderBottom: 'none' }}>
                    <div className='d-flex align-items-center' style={{ maxWidth: '320px' }}>
                        <h2 className='pb-0' style={{ textTransform: 'none' }}>{selectedRow?.category_name}</h2>
                    </div>
                    <div className='entities-tab'>
                        <div className='toolbar'>
                            <div className='toolbar-right' style={{ position: "relative" }} ref={toolbarRef}>
                                {/* FIXED: Pass the selected row's category ID directly */}
                                <button
                                    className="dark-border gray-btn mx-2"
                                    type='button'
                                    // onClick={editCategory}
                                    onClick={() => { history.push(`/category/edit-category/${selectedRow.category_id}`); }}
                                    style={{ width: "100px" }}
                                >
                                    Edit
                                </button>
                                <button
                                    className="drawer-dots"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleToolbarDropdown();
                                    }}
                                >
                                    <MoreHorizontal size={18} />
                                </button>

                                {toolbarDropdownOpen && (
                                    <div
                                        className="backdrop-cls"
                                        style={{
                                            position: "absolute",
                                            top: 40,
                                            right: 0,
                                            background: "white",
                                            boxShadow: "0px 1px 4px 0px #0000001A",
                                            zIndex: 1000,
                                            minWidth: 152,
                                            borderRadius: 8,
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <div className="btn-align-forall">

                                            <div className="common-for-all">
                                                <button onClick={() => {
                                                    const actionType = selectedRow.status_text === 'Active' ? 'deactivate' : 'activate';
                                                    openDeactivateModal(selectedRow.category_id, actionType);
                                                    setToolbarDropdownOpen(false);
                                                }}>
                                                    {selectedRow.status_text === 'Active' ? 'Deactivate' : 'Activate'}
                                                </button>
                                            </div>
                                            <div className="common-for-all">
                                                <button onClick={() => { openArchiveModal(selectedRow.category_id, selectedRow.category_name); setToolbarDropdownOpen(false); }} className="deactivate-cls">
                                                    Archive
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="drawer-tabs" style={{ marginBottom: '20px' }}>
                    <button
                        className={drawerTab === 'general-info' ? 'active' : ''}
                        onClick={() => setDrawerTab('general-info')}
                    >
                        General
                    </button>
                    <button
                        className={drawerTab === 'additional-info' ? 'active' : ''}
                        onClick={() => setDrawerTab('additional-info')}
                    >
                        Additional
                    </button>
                </div>
                <div className="drawer-content">
                    {drawerTab === 'general-info' && (
                        <div className="tab-panel general-info-panel">
                            <div className='' style={{ background: 'var(--Background-White, #FFF)', marginBottom: '10px', boxShadow: 'rgba(0, 0, 0, 0.08) 0px 4px 12px' }}>
                                <div className='px-15 py-20' style={{ borderBottom: '.0625rem solid rgba(46, 54, 80, .125)', color: 'var(--Gray-900, #212529)', padding: '20px 15px', fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: 'normal', background: '#F8F9FA', borderRadius: ' 12px 12px 0 0' }}>Basic Info</div>
                                <div className='bg-white' style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(2, 1fr)',
                                    gap: '20px',
                                    border: '1px solid #ffffffff',
                                    boxShadow: 'rgba(0, 0, 0, 0.08) 0px 4px 12px',
                                    borderRadius: '0 0 12px 12px',
                                    padding: '20px',
                                    alignItems: 'start'
                                }}>

                                    {/* Category Name Field - Dynamic layout based on content length */}
                                    <div className="field-block" style={{
                                        borderBottom: 'none',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        // minHeight: '60px',
                                        gridColumn: isCategoryNameOverflowing(selectedRow.category_name) ? '1 / -1' : '1',
                                        gridRow: '1',
                                        padding: '0px'
                                    }}>
                                        <div className="field-label">Category Name</div>
                                        <div className="field-value" style={{
                                            wordWrap: 'break-word',
                                            overflowWrap: 'break-word',
                                            whiteSpace: 'normal'
                                        }}>
                                            {selectedRow.category_name}
                                        </div>
                                    </div>

                                    {/* Status Field - Position depends on Category Name length */}
                                    <div className="field-block" style={{
                                        borderBottom: 'none',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        // minHeight: '60px',
                                        gridColumn: isCategoryNameOverflowing(selectedRow.category_name) ? '1' : '2',
                                        gridRow: isCategoryNameOverflowing(selectedRow.category_name) ? '2' : '1',
                                        padding: '0px'
                                    }}>
                                        <div className="field-label">Status</div>
                                        <div className="field-value">
                                            <span className={`status ${typeof selectedRow?.status_text === 'string' ? selectedRow.status_text?.toLowerCase() : ''}`}>
                                                {selectedRow.status_text || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                            </span>
                                        </div>
                                    </div>

                                    {/* ID Field - Always full width with text wrapping */}
                                    <div className="field-block" style={{
                                        borderBottom: 'none',
                                        padding: '0px',
                                        gridColumn: '1 / -1',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'flex-start',
                                        width: '100%',
                                        // minHeight: '60px'
                                    }}>
                                        <div className="field-label">ID</div>
                                        <div className="field-value" style={{
                                            wordWrap: 'break-word',
                                            overflowWrap: 'break-word',
                                            whiteSpace: 'normal',
                                            lineHeight: '1.4'
                                        }}>
                                            {selectedRow?.external_id || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                        </div>
                                    </div>

                                    {/* Open ID Field - Always full width with text wrapping */}
                                    <div className="field-block" style={{
                                        borderBottom: 'none',
                                        padding: '0px',
                                        gridColumn: '1 / -1',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'flex-start',
                                        width: '100%',
                                        // minHeight: '60px'
                                    }}>
                                        <div className="field-label">Open ID</div>
                                        <div className="field-value d-flex align-items-center gap-2" style={{
                                            wordWrap: 'break-word',
                                            overflowWrap: 'break-word',
                                            whiteSpace: 'normal',
                                            flexWrap: 'wrap',
                                            lineHeight: 'normal',
                                            fontWeight: 600,
                                            fontSize: '12px'
                                        }}>
                                            <div style={{ position: "relative", display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                                <span
                                                    ref={openIdRef}
                                                    onClick={() => handleCopy(selectedRow.uuid)}
                                                    style={{
                                                        color: copied ? "#60aaffff" : "#2C7BE5",
                                                        cursor: "pointer",
                                                        textDecoration: "none",
                                                        transition: "color 0.3s",
                                                        marginRight: "4px",
                                                        wordBreak: 'break-all'
                                                    }}
                                                >
                                                    {selectedRow.uuid || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                </span>
                                                <Copy
                                                    size={13}
                                                    onClick={() => handleCopy(selectedRow.uuid)}
                                                    style={{ cursor: "pointer", color: copied ? "#60aaffff" : "#2C7BE5", flexShrink: 0 }}
                                                />
                                                {copied && <span style={{ fontSize: '12px', color: "#2C7BE5", flexShrink: 0 }}>Copied!</span>}

                                            </div>
                                        </div>
                                    </div>

                                    {/* Remaining fields in standard 2-column layout */}
                                    <div className="field-block" style={{ borderBottom: 'none', display: 'flex', flexDirection: 'column', padding: '0px' }}>
                                        <div className="field-label">Created By</div>
                                        <div className="field-value">{selectedRow.created_by || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                    </div>
                                    <div className="field-block" style={{ borderBottom: 'none', display: 'flex', flexDirection: 'column', padding: '0px' }}>
                                        <div className="field-label">Created Time</div>
                                        <div className="field-value">{formatDateTime(selectedRow.created_at) || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                    </div>
                                    <div className="field-block" style={{ borderBottom: 'none', display: 'flex', flexDirection: 'column', padding: '0px' }}>
                                        <div className="field-label" style={{ borderBottom: 'none' }}>Last Modified By</div>
                                        <div className="field-value">{selectedRow.modified_by || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                    </div>
                                    <div className="field-block" style={{ borderBottom: 'none', display: 'flex', flexDirection: 'column', padding: '0px' }}>
                                        <div className="field-label">Last Modified Time</div>
                                        <div className="field-value">{formatDateTime(selectedRow.modified_at) || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                    </div>
                                </div>
                            </div>
                            <div className='bg-white' style={{ border: '1px solid #ffffff', borderRadius: '12px', background: 'var(--Background-White, #FFF)', boxShadow: 'rgba(0, 0, 0, 0.08) 0px 4px 12px' }}>
                                <div className='px-15 py-20' style={{ borderBottom: '.0625rem solid rgba(46, 54, 80, .125)', color: 'var(--Gray-900, #212529)', padding: '20px 15px', fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: 'normal', background: '#F8F9FA', borderRadius: ' 12px 12px 0 0' }}>Business Info</div>
                                <div className='bg-white' style={{ display: 'grid', borderRadius: '0 0 12px 12px', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', boxShadow: '0px 0px 1px #fbfbfbff', padding: '20px' }}>
                                    <div className="field-block"
                                        style={{
                                            borderBottom: 'none',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            padding: '0px',
                                            gridColumn: isCategoryNameOverflowing(selectedRow.parent_name) ? '1 / -1' : '1',
                                            gridRow: '1',
                                        }}
                                    >
                                        <div className="field-label">Parent Category</div>
                                        <div className="field-value">
                                            <div className='d-flex align-items-center'>
                                                {selectedRow.parent_name !== null ? (

                                                    <div
                                                        onClick={() => handleParentCategoryClick(selectedRow.parent_category)}
                                                        // className="d-flex align-items-center gap-1 me-3"
                                                        style={{
                                                            color: '#2C7BE5',
                                                            textDecoration: 'underline',
                                                            fontWeight: '600',
                                                            fontSize: '12px',
                                                            background: 'none',
                                                            border: 'none',
                                                            padding: 0,
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        {selectedRow.parent_name}
                                                        {/* <div> */}
                                                        <SquareArrowOutUpRight size={14} strokeWidth={3} style={{ marginLeft: '4px' }} />
                                                        {/* </div> */}
                                                    </div>

                                                ) : (
                                                    <span>{selectedRow.parent_name || <span style={{ color: '#ADB5BD' }}>NA</span>}</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="field-block" style={{
                                        borderBottom: 'none',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        padding: '0px',
                                        gridColumn: isCategoryNameOverflowing(selectedRow.parent_name) ? '1' : '2',
                                        gridRow: isCategoryNameOverflowing(selectedRow.parent_name) ? '2' : '1',
                                    }}>
                                        <div className="field-label">Prefix</div>
                                        <div className="field-value">{selectedRow.prefix || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                    </div>
                                </div>
                            </div>
                            <div className='main-company-body-inner'>
                                <div className='edit-organisation-info d-flex justify-content-end align-items-center gap-2'>
                                </div>
                            </div>
                        </div>
                    )}
                    {drawerTab === 'additional-info' && (
                        <div className="tab-panel additional-info-panel" style={{ borderRadius: '12px', marginTop: '20px', boxShadow: 'rgba(0, 0, 0, 0.08) 0px 4px 12px' }}>
                            <p className="note-type-added cat-notes" style={{ fontSize: '14px', background: 'var(--Gray-100, #F8F9FA)', borderRadius: '12px 12px 0 0', borderBottom: '0.0625rem solid rgba(46, 54, 80, 0.125)' }}>Notes</p>
                            <label className="no-description-cls notes-preserve" style={{ padding: "20px 20px", background: "var(--Background-White, #FFF)", borderRadius: '0 0 12px 12px' }}>{selectedRow.notes || <span style={{ color: '#ADB5BD' }}>NA</span>}</label>
                        </div>
                    )}
                </div>
            </div>
        </div>
    </>
  );
};

export default CategoryInfoDrawer;